import {
  getSectionsState,
  getAnswerSectionState,
  getQuestionBySectionMap,
  getCurrentSlide
} from './wizard-section-state-utils';
import { QuestionKeys, SectionKey } from 'types';

const isKeyofPvWizardResultsQueryVariables = (value: string): boolean =>
  Object.keys(QuestionKeys).includes(value);

export const findCurrentSlide = (
  initialAnswerState: PvWizardResultsQueryVariables,
  sectionOrder: SectionKey[],
  sectionData: PvWizardSections
): {
  initialSectionOrderIndex: number;
  initialSlideKey: keyof PvWizardResultsQueryVariables;
  initialActiveSlideIndex: number;
} => {
  const questionsBySectionMap = getQuestionBySectionMap(sectionOrder, sectionData);

  const sectionState = getSectionsState({
    sectionOrder,
    questionsBySectionMap,
    answerState: initialAnswerState
  });

  const answeredSectionState = getAnswerSectionState({
    sectionState,
    answerState: initialAnswerState
  });

  const currentSection = getCurrentSlide(answeredSectionState);

  const initialSectionOrderIndex = currentSection?.sectionOrderIndex ?? 0;
  const initialSlideKey = answeredSectionState[initialSectionOrderIndex].missingQuestions[0];
  const initialActiveSlideIndex = answeredSectionState[
    initialSectionOrderIndex
  ].questionsOfSection.findIndex(value => value === initialSlideKey);

  const typedInitialSlideKey = (
    isKeyofPvWizardResultsQueryVariables(initialSlideKey) ? initialSlideKey : QuestionKeys.houseType
  ) as keyof PvWizardResultsQueryVariables;

  return {
    initialSectionOrderIndex,
    initialSlideKey: typedInitialSlideKey,
    initialActiveSlideIndex
  };
};
